import { Topic } from '../types';

class PopularTopicsRepository extends ArticleRepository<Topic> {
  getMany() {
    return this._getMany({ url: '/topics/popular', cache: 'always' });
  }
}

export const popularTopicsRepository = new PopularTopicsRepository();
